export default "__VITE_ASSET__Br6msumL__"